module.exports = "../../vba-tools.JPG";